import { Stack } from '@mui/material';
import Typography from '../../components/Typography';
import { useTranslation } from 'react-i18next';
import { i18nNS } from '../../i18n';
import { List, restrictedPageClasses, Root } from './styles';
import AcadlyLogo from '../../icons/AcadlyLogo';
import RestrictedIcon from '../../icons/RestrictedIcon';

const RestrictedPage = () => {
  const { t } = useTranslation([i18nNS.RESTRICTED, i18nNS.SHARED]);
  return (
    <Root>
      <Stack pt={16} px={8} gap={2}>
        <AcadlyLogo />
        <Typography variant="h4Bold">{t('for_powerpoint', { ns: i18nNS.SHARED })}</Typography>
      </Stack>
      <Stack className={restrictedPageClasses.description} justifyContent="center" px={8}>
        <Stack direction="row" alignItems="start" gap={3}>
          <Stack px={3.5}>
            <RestrictedIcon size={32} />
          </Stack>
          <Stack flex={1} gap={1}>
            <Typography variant="h4Medium">{t('restricted_access', { ns: i18nNS.RESTRICTED })}</Typography>
            <Stack>
              <Typography variant="paragraphMedium">
                {t('you_don_t_have_access_to_this_activity_it_could_be_because', { ns: i18nNS.RESTRICTED })}
              </Typography>
              <List>
                <li>
                  <Typography variant="paragraphMedium" lineHeight={1}>
                    {t('you_are_not_an_instructor_in_the_acadly_course_that_has_this_activity', {
                      ns: i18nNS.RESTRICTED,
                    })}
                  </Typography>
                </li>
                <li>
                  <Typography variant="paragraphMedium" lineHeight={1}>
                    {t('you_are_not_an_in_charge_of_the_lecture_that_has_this_activity', {
                      ns: i18nNS.RESTRICTED,
                    })}
                  </Typography>
                </li>
                <li>
                  <Typography variant="paragraphMedium" lineHeight={1}>
                    {t('this_activity_has_been_removed', {
                      ns: i18nNS.RESTRICTED,
                    })}
                  </Typography>
                </li>
              </List>
              <Typography variant="paragraphMedium">
                {t('to_replace_this_activity_please_add_a_new_slide_and_remove_this_slide', {
                  ns: i18nNS.RESTRICTED,
                })}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Root>
  );
};
export default RestrictedPage;
